//External
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatMoney, formatMoneyLocalString } from "utils";

/*******************
@Purpose : Used for break down modal
@Parameter : {breakDownObj,handleClose,isEmailMeShow,showModal}
@Author : INIC
******************/
function BreakDownModal({
  breakDownObj,
  handleClose,
  isEmailMeShow,
  showModal,
  emailMeQuota,
  deliveryType,
  deliveryFee,
  returnFee,
  is_pickup_selected,
  start_address,
  return_address,
  one_way_option,
}) {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/

  return (
    <Modal
      show={showModal}
      // centered
      // aria-labelledby="contained-modal-title-vcenter"
      className="breakdown-modal pl-0"
      onHide={handleClose}
    >
      <Modal.Header
        closeButton
        className="text-left flex-column justify-content-start align-items-start"
      >
        <h3 className="modal-title">Price Details</h3>

        {isEmailMeShow && (
          <Button
            variant="link"
            className="p-0 link-btn text-decoaration-none ff-hel-reg gtEmailMeQuote"
            onClick={emailMeQuota}
          >
            Email me quote
          </Button>
        )}
      </Modal.Header>
      <Modal.Body className="px-0">
        {breakDownObj?.rentalCharge && (
          <ul className="list-unstyled mb-0 rental-list mt-space-0">
            <li>
              <div className="rental-charges">
                <span className="ff-hel-reg">
                  ${formatMoneyLocalString(breakDownObj.perDayCharge)} x{" "}
                  {breakDownObj.days}d
                </span>
                <span className="ff-hel-med">
                  ${formatMoney(breakDownObj.rentalCharge)}
                </span>
              </div>

              {breakDownObj.hours > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">
                    ${breakDownObj.perHourCharge} x {breakDownObj.hours}h
                  </span>
                  <span className="ff-hel-med">
                    ${formatMoney(breakDownObj.totalHourCharge)}
                  </span>
                </div>
              )}

              {breakDownObj.weeklyDiscount > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Weekly Discount</span>
                  <span className="text-success ff-hel-med">
                    -${formatMoney(breakDownObj.weeklyDiscount)}
                  </span>
                </div>
              )}

              {breakDownObj.monthlyDiscount > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Monthly Discount</span>
                  <span className="text-success ff-hel-med">
                    -${formatMoney(breakDownObj.monthlyDiscount)}
                  </span>
                </div>
              )}

              {breakDownObj.underageFee > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">
                    Underage Fee ({breakDownObj.underageFeePercent}%)
                  </span>
                  <span className="ff-hel-med">
                    ${formatMoney(breakDownObj.underageFee)}
                  </span>
                </div>
              )}

              {!is_pickup_selected && start_address && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">
                    {one_way_option ? "Delivery Fee" : "Delivery & Return Fee"}
                  </span>

                  <span className="ff-hel-med">
                    {breakDownObj.deliveryFee !== null ? (
                      breakDownObj.deliveryFee === 0 ? (
                        <span className="text-success">comp</span>
                      ) : breakDownObj.deliveryFee > 0 ? (
                        "$" + formatMoney(Math.round(breakDownObj?.deliveryFee))
                      ) : (
                        "TBD"
                      )
                    ) : (
                      "Calculating..."
                    )}
                  </span>
                </div>
              )}
              {return_address && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Return Fee</span>
                  <span className="ff-hel-med">
                    {breakDownObj.returnFee !== null ? (
                      breakDownObj.returnFee === 0 ? (
                        <span className="text-success">comp</span>
                      ) : breakDownObj.returnFee > 0 ? (
                        "$" + formatMoney(Math.round(breakDownObj?.returnFee))
                      ) : (
                        "TBD"
                      )
                    ) : (
                      "Calculating..."
                    )}
                  </span>
                </div>
              )}

              {breakDownObj?.securityDepositAdmin > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Security Deposit</span>
                  <span className="ff-hel-med">
                    ${formatMoney(breakDownObj?.securityDepositAdmin)}
                  </span>
                </div>
              )}

              {breakDownObj?.vehicleProtectionValue > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Collision Damage Waiver</span>
                  <span className="ff-hel-med">
                    ${formatMoney(breakDownObj?.vehicleProtectionValue)}
                  </span>
                </div>
              )}

              {breakDownObj?.deductible > 0 && (
                <div className="rental-charges">
                  <span className="ff-hel-reg">Deductible</span>
                  <span className="text-success ff-hel-med">
                    -${formatMoney(breakDownObj?.deductible)}
                  </span>
                </div>
              )}
              <div className="rental-charges">
                <span className="ff-hel-reg">Taxes & Fees</span>
                <span className="ff-hel-med">
                  ${formatMoney(breakDownObj.taxesFees)}
                </span>
              </div>
            </li>

            <li className="rental-charges">
              <h3 className="mb-0 ff-hel-bold text-dark font-24">
                Total Charges
              </h3>
              <h3 className="mb-0 ff-hel-bold text-dark total-price font-24">
                ${formatMoney(breakDownObj.totalCharge)}
              </h3>
            </li>
          </ul>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default BreakDownModal;
